import ProfileDropdown from "./ProfileDropdown";
import { OptimizedSvg } from "@components/common/OptimizedSvg";
import { userProfile } from "@tvet-mis/psda-assets";
import { useProfile } from "./services/GetProfile";
import isEmpty from "@utils/isEmpty";

const Profile = () => {
	const { data } = useProfile();
	const profilePicture = data?.profilePicture;
	const firstName = data?.firstName;
	const lastName = data?.lastName;

	const hasName = !isEmpty(firstName) || !isEmpty(lastName);
	const fullName = hasName ? `${firstName || ""} ${lastName || ""}`.trim() : "";

	return (
		<div className="flex items-center bg-gray-100 rounded-full px-4 py-1">
			{profilePicture ? (
				<img src={profilePicture} alt="Profile" className="h-10 w-10 rounded-full items-center justify-center mr-2" />
			) : (
				<OptimizedSvg src={userProfile} alt="user profile" className="user-profile mr-2" cacheKey="user-profile" />
			)}
			{hasName && (
				<div>
					<div
						className="font-medium truncate max-w-[80px] sm:max-w-[100px] md:max-w-[150px] lg:max-w-[100px]"
						title={fullName}>
						{fullName}
					</div>
				</div>
			)}

			<ProfileDropdown />
		</div>
	);
};

export default Profile;
